export enum AgencyKeys {
  Id = 'ID',
  Name = 'FullName',
  Active = 'Active',
  MaxDeviceCount = 'MaxDeviceCount',
  Description = 'Description',
  TokenLifeTime = 'TokenLifeTime',

  Email = 'Email',
  Member = 'Member',
}

export interface Agency {
  [AgencyKeys.Id]: string
  [AgencyKeys.Name]: string
  [AgencyKeys.MaxDeviceCount]: number
  [AgencyKeys.Active]: boolean
  [AgencyKeys.TokenLifeTime]: number
}

export interface AgencyPayload {
  [AgencyKeys.Name]: string
  [AgencyKeys.Description]: string
  [AgencyKeys.MaxDeviceCount]: number
  [AgencyKeys.Member]: {
    [AgencyKeys.Name]: string
    [AgencyKeys.Email]: string
  }
}
